<h2 mat-dialog-title>Lisää uusi tiimi</h2>
<mat-dialog-content>
  <form novalidate>
    <mat-form-field style="width: 100%">
      <mat-label>Avain</mat-label>
      <input matInput [formField]="lomake.avain" style="text-transform: uppercase" />
      <mat-hint>Muoto: ISOT_KIRJAIMET_JA_ALAVIIVAT, esim. TULOSNURKKA. Lisää vakio KirjanpitajaTiimiAvaimet-luokkaan.</mat-hint>
      @if (onkoVirhe(lomake.avain, 'avain-virheellinen') && (lomake.avain().dirty() || lomake.avain().touched())) {
        <mat-error>Avain saa sisältää vain isoja kirjaimia, numeroita ja alaviivoja, ja sen täytyy alkaa kirjaimella</mat-error>
      }
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Nimi</mat-label>
      <input matInput [formField]="lomake.nimi" />
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Voimassa alkaen</mat-label>
      <input matInput [matDatepicker]="dpAlku" [formField]="lomake.alku" />
      <mat-datepicker-toggle matSuffix [for]="dpAlku"></mat-datepicker-toggle>
      <mat-datepicker #dpAlku></mat-datepicker>
      <mat-hint>Tyhjä = voimassa aikojen alusta saakka</mat-hint>
    </mat-form-field>
  </form>
  @if (virhe) {
    <div class="red-text" style="margin-top: 8px">{{ virhe }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-secondary-button style="margin-right: 10px" (click)="peruuta()" actionId="Peruuta uuden tiimin luonti">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Luo uusi tiimi" [actionContext]="[lomake.avain().value(), lomake.nimi().value(), lomake.alku().value()]" [disabled]="!lomake().valid()">Luo</app-primary-button>
</mat-dialog-actions>
